import { render, staticRenderFns } from "./FactsList.vue?vue&type=template&id=0b0c72ef&scoped=true&"
import script from "./FactsList.vue?vue&type=script&lang=js&"
export * from "./FactsList.vue?vue&type=script&lang=js&"
import style0 from "./FactsList.vue?vue&type=style&index=0&id=0b0c72ef&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b0c72ef",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VList } from 'vuetify/lib/components/VList';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VList,VSubheader,VTextField})
